module.exports = __webpack_public_path__ + "static/media/ruhtinas-white-bg-gold-400x240.1c9950d5.png";